import { asset } from '@/lib/assets'
import { SITE_URL } from '@/lib/siteUrl'
import {
  CAMPAIGN_ICON_FEEDBACK,
  CAMPAIGN_ICON_FORUM,
  CAMPAIGN_ICON_MENU_BOOK,
  CAMPAIGN_PAGE_BACKGROUND,
} from '@/components/campaign/sharedAssets'
import type { InterviewPracticeCampaignConfig } from '@/components/campaign/types'

/** Figma: Landing-page-meritlens → Final (2154:269) → Cloud DevOps (Desktop 10 / iPhone 14 & 15 Pro - 4). */
const IMG_HERO = asset('/assets/images/data-analytics-engineering/hero-cloud-pipeline.png')
const IMG_OFFER_CARD = asset('/assets/images/data-analytics-engineering/cloud-offer-card.png')

const OG_IMAGE = `${SITE_URL}/images/backgroundImages.jpg`

export const cloudDevOpsCampaignConfig: InterviewPracticeCampaignConfig = {
  path: '/cloud-devops-platform-engineering',
  analyticsSource: 'cloud_devops_platform_engineering',
  analytics: {
    pageViewed: 'cloud_devops_page_viewed',
    ctaClicked: 'cloud_devops_cta_clicked',
    checkoutStarted: 'cloud_devops_checkout_started',
  },
  idPrefix: 'cdpe',

  seo: {
    title: 'Cloud, DevOps & Platform Engineering Interview Practice',
    description:
      'Put your cloud and DevOps skills to the test with realistic technical interview practice on infrastructure, automation, CI/CD, and platform engineering.',
    openGraphTitle: 'Cloud, DevOps & Platform Engineering Interview Practice | meritlens',
    openGraphDescription:
      'Your next DevOps interview — your time to stand out. Structured feedback on production decisions and platform scenarios.',
    twitterDescription:
      'Practice DevOps and platform engineering interviews with realistic scenarios and structured feedback before your next round.',
    heroImageForSharing: OG_IMAGE,
    heroImageAlt: 'Cloud DevOps and platform engineering interview practice with meritlens',
  },

  hero: {
    roleBadge: 'Cloud, DevOps & Platform Engineering',
    titleLine: 'Your next DevOps interview.',
    titleAccent: 'Your time to stand out.',
    heroImageSrc: IMG_HERO,
    heroImageAlt: 'Cloud DevOps and platform engineering interview practice with meritlens',
    caption:
      'Put your cloud and DevOps skills to the test with realistic technical interview practice. Tackle questions on infrastructure, automation, CI/CD, and platform engineering, and get structured feedback to help you prepare for your next interview.',
  },

  pageBackgroundImage: CAMPAIGN_PAGE_BACKGROUND,

  offer: {
    cardTitle: 'No more failed technical rounds',
    offerPreviewImage: IMG_OFFER_CARD,
    microcopy: 'Practice directly on your own projects',
    bullets: [
      'Practice explaining your production decisions under real interview pressure',
      'Pinpoint weak answers with structured feedback before the hiring panel calls',
    ],
  },

  why: {
    intro:
      'Practise explaining your technical decisions, tackling infrastructure challenges, and answering questions in an interview-like experience.',
    features: [
      {
        icon: CAMPAIGN_ICON_FORUM,
        titleDesktop: 'Realistic technical interviews',
        titleMobile: 'Realistic technical interviews',
        description:
          'Practise interview-style questions across DevOps and Platform Engineering.',
      },
      {
        icon: CAMPAIGN_ICON_MENU_BOOK,
        titleDesktop: 'Test your problem-solving skills.',
        titleMobile: 'Test your problem-solving skills',
        description:
          'Work through technical questions that challenge your understanding of systems and infrastructure.',
      },
      {
        icon: CAMPAIGN_ICON_FEEDBACK,
        titleDesktop: 'Get structured feedback.',
        titleMobile: 'Get structured feedback',
        description:
          'Identify your strengths and areas to improve before your next interview.',
      },
    ],
  },
}
